const QRCODE_READ_INTERVAL = 1500; // WebCameraの処理停止待ち時間

export { QRCODE_READ_INTERVAL };
